import React from "react";
import Slider from "react-slick";
import { useLocation } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function MainSlider() {
  const location = useLocation();

  const slider = {
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 15000,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const slides = {
    Adaptive: [
      {
        text: "Outcome, income, & buffer strategies for existing client portfolios",
        title: "Adaptive Advisor",
        img: "/login-img1.svg",
      },
      {
        text: "Set your practice apart with client-friendly Options Intelligence Reports",
        title: "Adaptive Advisor Firm",
        img: "/login-img2.svg",
      },
      {
        text: "Easily design cost-effective overlays for hedging & income",
        title: "Adaptive Investor",
        img: "/login-img3.svg",
      },
    ],
    Advisor: [
      {
        text: "Outcome, income, & buffer strategies for existing client portfolios",
        title: "Adaptive Advisor",
        img: "/login-img1.svg",
      },
      {
        text: "Set your practice apart with cost-effective overlays for hedging & income",
        title: "Adaptive Advisor",
        img: "/login-img2.svg",
      },
      {
        text: "See incremental income & downside protection for your client portfolios",
        title: "Adaptive Advisor",
        img: "/login-img3.svg",
      },
      {
        text: "Buy down portfolio risk to an asset-allocation target",
        title: "Adaptive Advisor",
        img: "/login-img2.svg",
      },
    ],
    "Advisor Firm": [
      {
        text: "Outcome, income, & buffer strategies for existing client portfolios",
        title: "Adaptive Advisor Firm",
        img: "/login-img1.svg",
      },
      {
        text: "Set your practice apart with client-friendly Options Intelligence Reports",
        title: "Adaptive Advisor Firm",
        img: "/login-img2.svg",
      },
      {
        text: "See incremental income & downside protection for your client portfolios",
        title: "Adaptive Advisor Firm",
        img: "/login-img3.svg",
      },
      {
        text: "Buy down portfolio risk to an asset-allocation target",
        title: "Adaptive Advisor Firm",
        img: "/login-img2.svg",
      },
    ],
    Investor: [
      {
        text: "Outcome, income, & buffer strategies for your existing portfolios",
        title: "Adaptive Investor",
        img: "/login-img1.svg",
      },
      {
        text: "Easily design cost-effective overlays for hedging & income",
        title: "Adaptive Investor",
        img: "/login-img2.svg",
      },
      {
        text: "Buy down portfolio risk to an asset-allocation target",
        title: "Adaptive Investor",
        img: "/login-img3.svg",
      },
      {
        text: "See incremental income & downside protection for your portfolios",
        title: "Adaptive Investor",
        img: "/login-img2.svg",
      },
    ],
  };

  const getPlanFromUrl = () => {
    const storedPlan = sessionStorage.getItem("selectedPlan");
    if (storedPlan) {
      return JSON.parse(storedPlan).plan;
    }
    const path = window.location.pathname.toLowerCase();
    if (path.includes("investorsignup")) return "Investor";
    if (path.includes("advisorsignup")) return "Advisor";
    if (path.includes("advisorfirmsignup")) return "Advisor Firm";
    return "Adaptive";
  };

  const [selectedPlan, setSelectedPlan] = React.useState(getPlanFromUrl);

  React.useEffect(() => {
    setSelectedPlan(getPlanFromUrl());
  }, [location.pathname, location.search]);

  const activeSlides = slides[selectedPlan] || slides["Adaptive"];
  return (
    <Slider {...slider} className="ai-slider">
      {activeSlides.map((slide, index) => (
        <div className="ai-slide" key={index}>
          <p style={{ paddingBottom: 50 }}>
            {slide.text}
            <b> - {slide.title}</b>
          </p>
          <div className="ai-slide-image">
            <img src={process.env.PUBLIC_URL + slide.img} alt={selectedPlan} />
          </div>
        </div>
      ))}
    </Slider>
  );
}

export default MainSlider;
